import Vue from 'vue'
import './plugins/vuetify'

// sync localstorage with store
import lsSync from './utils/lsSync'
lsSync.syncData()

import './assets/sass/_variables.scss'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import common from './utils/common'

import VueRangedatePicker from 'vue-rangedate-picker'

Vue.use(VueRangedatePicker)

// global compponents
import Default from './layouts/Default'
import NoSidebar from './layouts/NoSidebar'
import TopHeader from './layouts/TopHeader'
import vTextareaAutocomplete from './components/common/v-textarea-autocomplete'

Vue.config.productionTip = false


Vue.component('default-layout', Default);
Vue.component('no-sidebar-layout', NoSidebar);
Vue.component('TopHeader-layout', TopHeader);
Vue.component('vTextareaAutocomplete', vTextareaAutocomplete)


Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});

new Vue({
  router,
  store,
  common,
  render: h => h(App)
}).$mount('#app')
